import { Box, Chip, Divider, Modal, Select, Stack, Typography } from '@mui/material';
import { isEmpty, map } from 'lodash';
import React from 'react';
import Button from '../../../components/Button';
import { addUserInsuranceApi, updateUserInsuranceApi } from '../../../utils/api';
import { useMutation } from 'react-query';
import useStore from '../../../Store/Store';
import TextInput from '../../../components/TextInput';
import { INSURANCE_COMPANIES, INSURANCE_COMPANIES_IMAGE } from '../../../constants';

const AddInsuranceModal = ({ show, onClose, recipient, refetch, activeEditData }) => {
  const user = useStore((state) => state.user);
  const [state, setState] = React.useState({
    title: '',
    member: '',
    group: '',
    bin: '',
    benefitPlan: '',
    plan: '',
    date: '',
    dependents: [],
    prices: [],
    errorMessage: '',
  });

  React.useEffect(() => {
    if (!isEmpty(activeEditData)) {
      setState((prev) => {
        return {
          ...prev,
          title: activeEditData?.title,
          member: activeEditData?.member,
          group: activeEditData?.group,
          bin: activeEditData?.bin,
          benefitPlan: activeEditData?.benefitPlan,
          plan: activeEditData?.plan,
          date: activeEditData?.date,
          dependents: activeEditData?.dependents,
          prices: activeEditData?.prices,
        };
      });
    }
  }, [activeEditData]);

  const addInsuranceHandler = useMutation(addUserInsuranceApi, {
    onSuccess: async ({ data }) => {
      setState({
        title: '',
        member: '',
        group: '',
        bin: '',
        benefitPlan: '',
        plan: '',
        date: '',
        dependents: [],
        prices: [],
        errorMessage: '',
      });
      refetch();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const updateInsuranceHandler = useMutation(updateUserInsuranceApi, {
    onSuccess: async ({ data }) => {
      setState({
        title: '',
        member: '',
        group: '',
        bin: '',
        benefitPlan: '',
        plan: '',
        date: '',
        dependents: [],
        prices: [],
        errorMessage: '',
      });
      refetch();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const { title, member, group, bin, benefitPlan, plan, date, dependents, prices } = state;

    if (
      isEmpty(title) ||
      isEmpty(member) ||
      isEmpty(group) ||
      isEmpty(bin) ||
      isEmpty(benefitPlan) ||
      isEmpty(plan) ||
      isEmpty(date) ||
      isEmpty(dependents) ||
      isEmpty(prices)
    ) {
      setState((prev) => {
        return { ...prev, errorMessage: 'Fill all the fields' };
      });
      return;
    }

    const body = {
      imageUrl: INSURANCE_COMPANIES_IMAGE[title],
      title,
      member,
      group,
      bin,
      benefitPlan,
      plan,
      date,
      dependents,
      prices,
    };

    if (!isEmpty(activeEditData)) {
      updateInsuranceHandler.mutate({
        userId: user?._id,
        recipientId: recipient?._id,
        insuranceId: activeEditData?._id,
        body,
      });
    } else {
      addInsuranceHandler.mutate({ userId: user?._id, recipientId: recipient?._id, body });
    }
  };

  const onCloseModal = () => {
    setState({
      title: '',
      member: '',
      group: '',
      bin: '',
      benefitPlan: '',
      plan: '',
      date: '',
      dependents: [],
      prices: [],
      errorMessage: '',
    });
    onClose();
  };

  const handleSetDependents = (e) => {
    if (e.key === 'Enter') {
      setState((prev) => {
        return { ...prev, dependents: [...prev.dependents, e.target.value] };
      });
      e.target.value = '';
    }
  };
  const handleSetPrices = (e) => {
    if (e.key === 'Enter') {
      setState((prev) => {
        return { ...prev, prices: [...prev.prices, e.target.value] };
      });
      e.target.value = '';
    }
  };

  const handleDeleteDependent = (idx) => {
    return setState((prev) => {
      prev.dependents.splice(idx, 1);
      return { ...prev };
    });
  };
  const handleDeletePrice = (idx) => {
    return setState((prev) => {
      prev.prices.splice(idx, 1);
      return { ...prev };
    });
  };

  return (
    <Modal
      open={show}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{ onClick: () => {} }}
      style={{ height: 'auto', overflow: 'scroll' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '30%',
          p: 6,
          bgcolor: 'background.paper',
          borderRadius: 2.5,
          position: 'relative',
          top: 20,
          left: '35%',
        }}
      >
        <Typography variant="h5" textAlign="center" marginBottom={'20px'}>
          Add Insurance
        </Typography>

        <Box sx={{ width: '100%', marginBottom: '20px' }}>
          <Select
            native
            fullWidth
            value={state.title}
            onChange={(event) => {
              const value = event.target.value;
              return setState((prevState) => {
                return { ...prevState, title: value };
              });
            }}
            style={{ borderRadius: 50 }}
          >
            <option value="">-- select insurance --</option>
            {map(INSURANCE_COMPANIES, (item, idx) => (
              <option value={item}>{item}</option>
            ))}
          </Select>
        </Box>

        <TextInput
          label="Member ID"
          value={state.member}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                member: e.target.value,
              };
            })
          }
        />
        <TextInput
          label="Group #"
          value={state.group}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                group: e.target.value,
              };
            })
          }
        />
        <TextInput
          label="BIN"
          value={state.bin}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                bin: e.target.value,
              };
            })
          }
        />
        <TextInput
          label="Benefit Plan"
          value={state.benefitPlan}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                benefitPlan: e.target.value,
              };
            })
          }
        />
        <TextInput
          label="Plan"
          value={state.plan}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                plan: e.target.value,
              };
            })
          }
        />
        <TextInput
          type="date"
          value={state.date}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                date: e.target.value,
              };
            })
          }
        />
        <TextInput label="Dependents" onKeyUp={handleSetDependents} />

        <Stack direction="row" spacing={1} marginBottom="15px">
          {state.dependents.map((item, idx) => (
            <Chip key={idx} label={item} variant="outlined" onDelete={() => handleDeleteDependent(idx)} />
          ))}
        </Stack>
        <TextInput label="Prices" onKeyUp={handleSetPrices} />
        <Stack direction="row" spacing={1} marginBottom="15px">
          {state.prices.map((item, idx) => (
            <Chip key={idx} label={item} variant="outlined" onDelete={() => handleDeletePrice(idx)} />
          ))}
        </Stack>

        <Typography variant="subtitle1" style={{ color: 'red', marginTop: '30px' }} textAlign="center">
          {state.errorMessage}
        </Typography>

        <Divider
          sx={{
            marginTop: 1,
            borderColor: '#E0E0E0',
          }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 2,
          }}
        >
          <Button text="Cancel" onClick={onCloseModal} bg="light" />
          <Button text="Submit" onClick={handleSubmit} loading={addInsuranceHandler.isLoading} />
        </Box>
      </Box>
    </Modal>
  );
};

export default AddInsuranceModal;
